<template>
    <div>
        <h4 v-lang.latest_posts></h4>
        <div class="latest_posts">
            <article class="latest_post" v-for="post in posts">
                <!--<figure>
                    <a href="blog-post.html" class="hover_effect h_link h_blue">
                        <img src="images/blog/thumb1.jpg" alt="Image">
                    </a>
                </figure>-->
                <div class="details">
                    <h6><a>{{post.title}}</a></h6>
                    <span><i class="fa fa-calendar"></i>{{formatDate(post.createdAt)}}</span>
                </div>
            </article>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import axiosInstance from '../../../HttpRequest';
    export default {
      data() {
        return {
          $language: '',
          posts: [],
        };
      },
      created : function(){
        var self = this;
        this.unsubscribe  = this.$store.subscribe((mutation,state) => {
          self.$language = self.$store.state.language;
        });
        axiosInstance.get(`/post?sort=id DESC&limit=3&where={"lang":"${self.$language}"}`).then((resp) => {
          self.posts = resp.data;
        });
      },
      beforeDestroy : function(){
        this.unsubscribe();
      },
      methods: {
        formatDate(date) {
          return moment(date).format('MMM DD, YYYY');
        },
      },
    }
</script>


// WEBPACK FOOTER //
// lastPosts.vue?8b1615a2